import { Component, OnInit } from '@angular/core'
import { CpmService } from 'app/service/cpm.service'
import { StoreService } from 'app/service/store.service'
import { FormControl } from '@angular/forms'
import { Router } from '@angular/router'

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit {
  searchInputControl = new FormControl()
  securityList = []
  searchResults = []

  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private router: Router
  ) {
    this.cpmService.getSecurityList().then(response => {
      this.securityList = response.map(x => x.securitySymbol)
    })
  }

  ngOnInit() {
    this.store.getSearchInputObservable().subscribe(symbol => {
      this.searchInputControl.setValue(symbol)
    })
    this.searchInputControl.valueChanges.subscribe(searchValue => {
      const newValueUppercase = searchValue.toUpperCase()
      this.searchResults = this.securityList
        .filter(x => x.startsWith(newValueUppercase))
        .splice(0, 5)
    })
  }

  onEnter(event) {
    if (this.searchInputControl.value === '') {
      return
    }
    const newValueUppercase = this.searchInputControl.value.toUpperCase()
    this.cpmService.getSecurityProfileNew(newValueUppercase)
  }

  onInput(event) {
    this.reRouteWhenURLNotInSecurityLevel()
    const newValueUppercase = this.searchInputControl.value
      .toUpperCase()
      .replace(/[^a-zA-Z\d\&-\s]+/g, '')
    this.searchInputControl.setValue(newValueUppercase)
    if (
      Object.getPrototypeOf(event) === Object.getPrototypeOf(new Event('input'))
    ) {
      this.cpmService.getSecurityProfileNew(newValueUppercase)
      event.target.blur()
      return
    }
    this.store.setSearchInputBehavior(newValueUppercase)
  }

  reRouteWhenURLNotInSecurityLevel() {
    if (
      this.router.url.indexOf('securities-level') < 0 &&
      this.router.url.indexOf('crm') < 0
    ) {
      this.router.navigate(['/securities-level/excecutive-summary'])
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/search-box/search-box.component.ts